/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  -----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
    Author: Johnny Palmer
  Author URL: http://sweetas.xyz
==========================================================================================*/


export default {
  ADD_ITEM (state, item) {
    state.products.unshift(item)
  },
  SET_PRODUCTS (state, products) {  
    state.products = products
  },
  // SET_COMMIT (state) {
  //   const s = state
  // },
  SET_DETAILS (state, details) {
    state.details = JSON.parse(details.data)
  },
  UPDATE_CONTACT_DETAILS (state, details) {  
    if (state.details === undefined) {
      state.details = {}
    }

    for (let i = 0; i <= Object.keys(details).length - 1; i++) {      
      if (state.details[Object.keys(details)[i]]  === undefined) {
        state.details[Object.keys(details)[i]]  = null
      }  
      state.details[Object.keys(details)[i]] = Object.values(details)[i]      
    }
  },
  UPDATE_DELIVERY_DETAILS (state, details) {  
    if (state.details === undefined) {
      state.details = {}
    }
    for (let i = 0; i <= Object.keys(details).length - 1; i++) {      
      if (state.details[Object.keys(details)[i]]  === undefined) {
        state.details[Object.keys(details)[i]]  = null
      }      
      state.details[Object.keys(details)[i]] = Object.values(details)[i]      
    }
  },
  UPDATE_DETAILS (state, details) {  
    if (state.details === undefined) {
      state.details = {}
    }
    for (let i = 0; i <= Object.keys(details).length - 1; i++) {      
      if (state.details[Object.keys(details)[i]]  === undefined) {
        state.details[Object.keys(details)[i]]  = null
      }      
      state.details[Object.keys(details)[i]] = Object.values(details)[i]      
    }
  },
  SET_SITES (state, sites) { 
    state.sites = JSON.parse(sites.data)
  },
  UPDATE_PRODUCT (state, product) {    
    const productIndex = state.products.findIndex(p => p.id === product.id)
    Object.assign(state.products[productIndex], product)
  },
  REMOVE_ITEM (state, itemId) {
    const ItemIndex = state.products.findIndex(p => p.id === itemId)
    state.products.splice(ItemIndex, 1)
  }
}
